import { createStore } from 'vuex';
import alerts from './alerts';
import article from './article';
import clients from './clients';
import companies from './companies';
import news from './news';
import popup from './popup';
import userInfo from './userInfo';

export default createStore({
  modules: {
    userInfo,
    news,
    alerts,
    companies,
    clients,
    popup,
    article,
  },
});
